import { render, staticRenderFns } from "./CollectionPointManagement.vue?vue&type=template&id=c0d5e468"
import script from "./CollectionPointManagement.vue?vue&type=script&lang=js"
export * from "./CollectionPointManagement.vue?vue&type=script&lang=js"
import style0 from "./CollectionPointManagement.vue?vue&type=style&index=0&id=c0d5e468&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports